import { useEffect, useMemo, useState } from 'react'

import { connect, useSelector } from 'react-redux'
import { getUser } from '../../../reducers/UserReducer'
import { getInstitutionSectors } from '../../../utils/api/institution'
import { callFunctionIfDefined } from '../../../utils/functionHelper'
import Selector from './Selector'
import { sortByString } from '../../../utils/arrayUtils'

import '../../../assets/internships-manager.scss'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import InstitutionsSelector from './Institution/InstitutionsSelector'
import { EntityCategories, getEntityCategory } from '../Badges/EntityBadge'
import { buildCategoryTree, getCategoryPath } from './utils/categoryTree'

const INSTITUTIONS_STYLE = { width: '275px' }
const SECTOR_STYLE = { width: '175px' }

const mapStateToProps = state => ({ user: getUser(state.getUser) })

const InstitutionsAndSectorsSelector = ({ disabled, institutions, internship, user, onSelect, useLinkedInstitutions }) => {
  const t = useSelector(selectTranslate)

  const [sectors, setSectors] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedInstitution, setSelectedInstitution] = useState(null)

  useEffect(() => {
    if (internship.institution) {
      setLoading(true)

      getInstitutionSectors(user, internship.institution).then(json => {
        if (json && json.data) {
          setSectors(sortByString(json.data, 'name'))
        }

        setLoading(false)
      })
    } else {
      setSectors([])
    }
  }, [internship.institution?.id])

  const handleInstitutionSelected = (value, selectedOptions) => {
    const institution = selectedOptions?.[selectedOptions.length - 1]?.data ?? null

    setSelectedInstitution(institution)
    callFunctionIfDefined(onSelect, [{ institution, sector: null }])
  }

  const handleSectorSelected = value => {
    const sector = sectors.find(s => s.id === value)

    callFunctionIfDefined(onSelect, [{ institution: selectedInstitution ?? internship.institution, sector }])
  }

  /** Only the institutions this school is linked to can be picked when the option is on. */
  const treeInstitutions = useMemo(() => buildCategoryTree(institutions, {
    t,
    isDisabled: institution => useLinkedInstitutions && getEntityCategory(institution) === EntityCategories.OTHERS
  }), [institutions, useLinkedInstitutions, t])

  const institutionPath = useMemo(() => {
    if (!internship.institution) {
      return []
    }

    return getCategoryPath(institutions.find(i => i.id === internship.institution.id) ?? internship.institution)
  }, [institutions, internship.institution])

  return (
    <div className='flex-row'>
      <InstitutionsSelector
        grouped
        disabled={disabled}
        institutions={treeInstitutions}
        placeholder={t('institution')}
        style={INSTITUTIONS_STYLE}
        values={institutionPath}
        onChange={handleInstitutionSelected}
      />
      {!loading && (
        <Selector
          data={sectors}
          dataKey='name'
          disabled={disabled || !sectors.length}
          onSelect={handleSectorSelected}
          showArrow={false}
          showEmpty
          showSearch
          style={SECTOR_STYLE}
          value={!internship.sector || internship.sector.parent === null ? -1 : internship.sector.id}
        />
      )}
      {loading && (
        <div className='flex-center'>
          <div className='loading-icon black' />
        </div>
      )}
    </div>
  )
}

export default connect(mapStateToProps)(InstitutionsAndSectorsSelector)
